'use client';

import { useFeatureFlags } from 'providers/ClientProviders/useFeatureFlags';
import { FC, PropsWithChildren } from 'react';
import { ContentGenerationListProvider } from './_context/ContentGenerationListContext';

const ContentGenerationLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { data: featureFlags } = useFeatureFlags();

  if (!featureFlags?.contentGenerationEnabled) return null;

  return <ContentGenerationListProvider>{children}</ContentGenerationListProvider>;
};

export default ContentGenerationLayout;
